import { ISocialMedia } from "./models";

export const queryKeys = {
  PRO_PRICE: 'pro-price',
  PLAN_PRICE: 'plan-price',
  PACKAGE_PRICE: 'package-price',
  SEND_FEEDBACK: 'send-feedback',
  PRO_FEATURES: 'pro-features',
  FEEDBACK_REASONS: 'feedback-reasons',
  FEEDBACKS: 'feedbacks'
};

export const baseSocialMedias: ISocialMedia[] = [
  {
    name: 'Telegram',
    logo: '/images/instagram.webp',
    url: `${process.env.NEXT_PUBLIC_INSTAGRAM}`,
    bgColor: 'bg-pink-200'
  },
  {
    name: 'instagram',
    logo: '/images/telegram.webp',
    url: `${process.env.NEXT_PUBLIC_TELEGRAM}`,
    bgColor: 'bg-blue-200'
  },
  {
    name: 'youtube',
    logo: '/images/youtube.webp',
    url: `${process.env.NEXT_PUBLIC_YOUTUBE}`,
    bgColor: 'bg-red-200'
  }
];
